<template>
  <div>
    <hshead title="我的订单" bgcolor="#fff"></hshead>
    <van-tabs
      v-model="active"
      swipeable
      title-active-color="#007dfa"
      color="#007dfa"
      @click="tabChange"
    >
      <van-tab title="全部"></van-tab>
      <van-tab title="待预约"></van-tab>
      <van-tab title="待审核"></van-tab>
      <van-tab title="打回"></van-tab>
      <van-tab title="已完成"></van-tab>
    </van-tabs>
    <div>
      <div class="order-ul">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text
          @load="onLoad"
        >
          <div class="order-li" v-for="(item, index) in list" :key="index">
            <div class="top-p">
              <div class="top-l">订单编号：{{ item.order.id }}</div>
              <div class="top-r">
                {{
                  orderStatusOptions.filter(
                    (w) => w.key == item.order.orderStatus
                  )[0].display_name
                }}
              </div>
            </div>
            <div class="content-box">
              <div class="content-top">
                <div class="left-img">
                  <img
                    :src="StaticWebSite + '/' + item.ext.storeLogoUrl"
                    alt
                    v-if="item.ext.storeLogoUrl"
                  />
                  <img src="~@/assets/images/order/icon.png" alt v-else />
                </div>
                <div class="center-p">
                  <div class="center-p-h1">{{ item.ext.storeFullName }}</div>
                  <div class="center-p-p">{{ item.order.createTimeTip }}</div>
                </div>
                <div class="right-icon">
                  <router-link
                    :to="`/Grapher/OrderDetail?orderId=${item.order.id}`"
                  >
                    <img src="~@/assets/images/order/ellipsis.png" alt />
                  </router-link>
                </div>
              </div>
              <div class="content-content">
                <div class="left-p">
                  {{ item.order.productName }}
                  <span>({{ item.order.shootValue }}张)</span>
                </div>
                <div class="right-p">
                  ¥{{ item.order.actualTotalMoney.toFixed(2) }}
                </div>
              </div>
              <div class="content-iconp iconp1">
                {{ item.order.shootHotelName }}
              </div>
              <div class="content-iconp iconp2">
                {{ item.order.shootAddress }}
              </div>
              <div
                class="content-iconp iconp3"
                v-if="item.ext.productShootType != 1"
              >
                {{ item.order.plantStartDateing }}－{{
                  item.order.plantEndDateing
                }}
              </div>
              <div
                v-if="item.ext.documentUrl"
                @click="lshootDocument(item.ext.documentUrl)"
                style="color: #00bbfb; margin-left: -0.5rem; width: 2rem"
                class="content-iconp"
              >
                预览拍摄标准
              </div>
            </div>
            <!-- <div class="order-li-bt" v-if="item.order.orderStatus<9">
              <van-button class="this-btn btn1" @click="handleTaskCancel(item.order)" v-if="item.order.orderStatus <= 8">拒单</van-button>
              <van-button class="this-btn btn2" @click="handleReplaceGrapher(item.order)" v-if="item.order.orderStatus <= 6">派单</van-button>
              <van-button class="this-btn btn1" @click="handleTaskAudit(item.order, true)" v-if="item.order.orderStatus == 5" style="width:2.1rem;">审核通过</van-button>
              <van-button class="this-btn btn1" @click="handleTaskAudit(item.order, false)" v-if="item.order.orderStatus == 5" style="width:2.2rem;">审核不通过</van-button>
            </div>-->
          </div>
        </van-list>
        <div v-if="finished" class="emptyDataDiv_gray">
          <div v-if="list.length == 0">
            <van-icon name="info" />
            <p>暂无订单</p>
          </div>
          <div v-else>没有更多了</div>
        </div>
      </div>
    </div>

    <!-- 拒单 -->
    <van-dialog
      v-model="dialogTaskCancelFormVisible"
      title="填写取消原因"
      show-cancel-button
      :beforeClose="beforeClose"
      @confirm="taskCancelData"
    >
      <van-cell-group name>
        <van-field
          v-model="reason"
          type="textarea"
          placeholder="请输入取消原因"
          rows="3"
          autosize
        ></van-field>
      </van-cell-group>
    </van-dialog>

    <!-- 底部导航 -->
    <van-tabbar v-model="activetab">
      <van-tabbar-item to="MissionHall">
        <span>任务中心</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_taskCenter.active : icon_taskCenter.inactive
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Income" icon="chart-trending-o">
        <span>收益</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_earnings.active : icon_earnings.inactive"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Order" icon="chart-trending-o">
        <span style="color:#304378">我的订单</span>
        <template #icon="props">
          <img :src="props.active ? icon_order.active : icon_order.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Center" icon="chart-trending-o">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon_user.active : icon_user.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import {
  Toast,
  Tabs,
  Tab,
  List,
  Button,
  Dialog,
  CellGroup,
  Cell,
  Field,
  NumberKeyboard,
  RadioGroup,
  Radio,
  Icon,
  Tabbar,
  TabbarItem,
} from "vant";
import {
  getGrapherTaskOrderPager as getMyTaskOrderPager,
  cancelTask as cancelTaskOrder,
} from "@/api/m/grapher";
import { getGrapherPagerByOrder, replaceGrapher } from "@/api/m/store";
import { orderStatusOptions } from "@/constant/enum/order";
// 任务中心
import taskCenter_icon from "@/assets/images/center/nav-1.png";
import taskCenter_icon_act from "@/assets/images/center/nav-1-act.png";
//收益
import earnings_icon from "@/assets/images/center/nav-2.png";
import earnings_icon_act from "@/assets/images/center/nav-2-act.png";
//我的订单
import order_icon from "@/assets/images/center/nav-6.png";
import order_icon_act from "@/assets/images/center/nav-6-act.png";
//我的
import user_icon from "@/assets/images/center/nav-7.png";
import user_icon_act from "@/assets/images/center/nav-7-act.png";

export default {
  name: "order",
  data() {
    return {
      StaticWebSite: window.StaticWebSite,
      active: 0,
      activetab:2,
      orderStatusOptions,
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        pn: 1,
        ps: 4,
      },
      curSelectedRow: null,
      curOrderStatus: null,
      OrderStatusArr: [
        { idx: 0, val: 0 },
        { idx: 1, val: 2 },
        { idx: 2, val: 5 },
        { idx: 3, val: 8 },
        { idx: 4, val: 9 },
      ],
      // 拒单
      dialogTaskCancelFormVisible: false,
      reason: "",
      icon_taskCenter: {
        active: taskCenter_icon_act,
        inactive: taskCenter_icon,
      },
      icon_earnings: {
        active: earnings_icon_act,
        inactive: earnings_icon,
      },
      icon_order: {
        active: order_icon_act,
        inactive: order_icon,
      },
      icon_user: {
        active: user_icon_act,
        inactive: user_icon,
      },
    };
  },
  created() {
    let { orderStatus } = this.$route.query;
    orderStatus = orderStatus || "";
    this.active = this.OrderStatusArr.filter(
      (w) => w.val == orderStatus
    )[0].idx;
    this.curOrderStatus = orderStatus;
    this.getMyTaskOrderPager();
  },
  methods: {
    onLoad() {
      if (this.listQuery.pn == 1) return;
      this.getMyTaskOrderPager();
    },
    onLoadByGrapher() {
      this.getGrapherPager(0);
    },
    tabChange(name, title) {
      console.info("tabChange", name, title);
      this.clearListFunc();
      this.active = name;
      this.curOrderStatus = this.OrderStatusArr.filter(
        (w) => w.idx == name
      )[0].val;
      this.getMyTaskOrderPager();
    },
    clearListFunc() {
      this.listQuery.pn = 1;
      this.list = [];
      this.finished = false;
    },
    lshootDocument(documentUrl) {
      if (documentUrl) {
        sessionStorage.setItem("_documentUrl", documentUrl);
        window.location.href = "/static/pdfShow.html";
      }
    },
    //列表数据
    getMyTaskOrderPager(orderStatus) {
      if (this.curOrderStatus > 0)
        this.listQuery.OrderStatus = this.curOrderStatus;
      //指定订单状态
      else this.listQuery.OrderStatus = null;
      getMyTaskOrderPager(this.listQuery)
        .then((response) => {
          console.info("response", response);
          const { code, msg, data } = response;
          if (code >= 0) {
            console.info("getMyTaskOrderPager -> data", data);
            this.listQuery.pn = this.listQuery.pn + 1;
            //
            if (data.totalRecord == 0) {
              this.loading = false;
              this.finished = true;
            } else {
              data.list.map((item) => {
                this.list.push(item);
              });
              // 加载状态结束
              this.loading = false;
              // 数据全部加载完成
              if (this.list.length >= data.totalRecord) {
                this.finished = true;
              }
            }
          }
        })
        .catch((response) => {
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    beforeClose(action, done) {
      if (action == "cancel") done();
      else done(false);
    },
    /************* 拒单（取消任务） *************/
    handleTaskCancel(row) {
      console.info("handleTaskCancel", row);
      this.curSelectedRow = row;
      this.reason = "";
      this.dialogTaskCancelFormVisible = true;
    },
    taskCancelData() {
      console.info("taskCancelData", this.reason, this.curSelectedRow);

      if (this.reason == "") {
        this.tips(`请输入取消原因`);
        return false;
      }

      this.load(true, "加载中...");
      let para = {
        ids: [this.curSelectedRow.id],
        reason: this.reason,
      };
      cancelTaskOrder(para)
        .then((response) => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips(`操作成功`);
            this.dialogTaskCancelFormVisible = false;
            //this.getList();
            this.curSelectedRow.orderStatus = 10;
          }
        })
        .catch((response) => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
  },
  components: {
    hshead,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-list": List,
    "van-button": Button,
    //"van-dialog": Dialog.Component,
    [Dialog.Component.name]: Dialog.Component,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-field": Field,
    "van-number-keyboard": NumberKeyboard,
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-icon": Icon,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.order-ul {
  margin-top: 0.5rem;
  .order-li {
    width: 6.7rem;
    background-color: #ffffff;
    box-shadow: 0rem 1px 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.1rem;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    .top-p {
      height: 0.82rem;
      line-height: 0.82rem;
      font-size: 0.24rem;
      display: flex;
      border-bottom: 1px solid #e5e5e5;
      .top-l {
        font-family: PingFang-SC-Medium;
        font-stretch: normal;
        letter-spacing: 0rem;
        color: #8a9096;
        padding-left: 0.27rem;
        width: 10rem;
      }
      .top-r {
        color: #00b8f5;
        text-align: right;
        padding-right: 0.27rem;
        width: (6.7-0.27 * 2)/2rem;
      }
    }
    .content-box {
      padding: 0.47rem 0.3rem;
      border-bottom: 1px solid #e5e5e5;
      .content-top {
        display: flex;
        margin-bottom: 0.15rem;
        .left-img {
          padding-right: 0.2rem;
          width: 0.62rem;
          img {
            width: 0.62rem;
            height: 0.62rem;
          }
        }
        .center-p {
          width: 4.6rem;
          padding-bottom: 0.4rem;
          .center-p-h1 {
            display: block;
            font-family: PingFangSC-Medium;
            font-size: 0.28rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0rem;
            color: #666666;
          }
          .center-p-p {
            height: 0.21rem;
            font-family: PingFangSC-Regular;
            font-size: 0.22rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0.4rem;
            letter-spacing: 0rem;
            color: #00bbfb;
          }
        }
        .right-icon {
          flex: 1;
          img {
            width: 0.64rem;
            height: 0.64rem;
            background-color: #ffffff;
          }
        }
      }
      .content-content {
        display: flex;
        .left-p {
          width: 100%;
          font-family: PingFangSC-Medium;
          font-size: 0.3rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #222222;
          span {
            font-size: 0.28rem;
          }
        }
        .right-p {
          flex: 1;
          text-align: right;
          font-family: PingFangSC-Medium;
          font-size: 0.28rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #ff3087;
        }
        margin-bottom: 0.4rem;
      }
      .content-iconp {
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.24rem;
        letter-spacing: 0rem;
        color: #8a9096;
        padding-left: 0.5rem;
        margin-top: 0.2rem;
        word-break: break-all;
        &.iconp1 {
          background: url(~@/assets/images/order/1.png) left center no-repeat;
          background-size: 0.2rem 0.22rem;
        }
        &.iconp2 {
          background: url(~@/assets/images/order/2.png) left center no-repeat;
          background-size: 0.19rem 0.24rem;
        }
        &.iconp3 {
          background: url(~@/assets/images/order/3.png) left center no-repeat;
          background-size: 0.22rem 0.21rem;
        }
      }
    }
    .order-li-bt {
      height: 1.17rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .this-btn {
        width: 1.7rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        border: solid 1px #00b8f5;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.6rem;
        letter-spacing: 0rem;
        color: #00b8f5;
        text-align: center;
        display: block;
        margin: 0 0.3rem;
        &.btn1 {
        }
        &.btn2 {
          background-color: #00b8f5;
          color: #fff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/grapher/order.vue